import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicGrouping({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M3.28 1.24l.07.05 2.33 2.33c.17.17.19.44.05.63l-.05.07-.36.36a.5.5 0 01-.63.05l-.07-.05-.87-.87v7.88l.87-.87a.5.5 0 01.63-.05l.07.05.36.36c.17.17.19.44.05.63l-.05.07-2.33 2.33a.5.5 0 01-.63.05l-.07-.05-2.33-2.33a.5.5 0 01-.05-.63l.05-.07.36-.36a.5.5 0 01.63-.05l.07.05.87.87V3.8l-.87.87a.5.5 0 01-.63.05l-.07-.05-.36-.36a.5.5 0 01-.05-.63l.05-.07 2.33-2.33a.5.5 0 01.63-.05zM8.5 11.75h7a.5.5 0 01.5.41v.59a.5.5 0 01-.41.5H8.5a.5.5 0 01-.5-.41v-.59a.5.5 0 01.41-.5h7.09zm7-4.5a.5.5 0 01.5.41v.59a.5.5 0 01-.41.5H8.5a.5.5 0 01-.5-.41v-.59a.5.5 0 01.41-.5h7.09zm0-4.5a.5.5 0 01.5.41v.59a.5.5 0 01-.41.5H8.5a.5.5 0 01-.5-.41v-.59a.5.5 0 01.41-.5h7.09z" />
    </svg>
  );
}

SvgBasicGrouping.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicGrouping.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicGrouping svgRef={ref} {...props} />);
export default ForwardRef;
